import './comp_cadet_record_book.css'

export const Comp_CRB_Roles_Resp=(props)=>{
    return(
        <div className="modal fade bd-example-modal-xl"  id="divCRBRolesResp" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-xl" role="document">
          <div className="modal-content">
          <div className="modal-header bg-primary">
              <h5 className="modal-title text-white" id="exampleModalLabel">Roles & Responsibilities</h5>
              <button type="button" className="close text-white" data-bs-dismiss="modal" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true" className="text-white">&times;</span>
              </button>
            </div>
            
           
            <div className="modal-body">
                 {/* form content  */}
                 <div class="steering-certificate">
           
            
           {/* Roles & Responsibilities content */}
           <div class="saperate-page div-4  text-start">
           <b>SECTION 2 </b><br/>
<b>Roles and Responsibilities</b> <br/><br/>
The main roles and responsibilities of the personnel involved in the delivery of a structured shipboard training programme are:
<br/><br/>
<b>Maritime Training Institution*</b><br/>
<ul>
    <li>Overall administration of the training programme including the pre-sea training period.</li>
    <li>Issues guidance as required and ensures that all concerned with the training programme play their parts.	</li>
    <li>Monitors the progress of the Cadet. Checks and comments on the appraisal report sent by the Shipboard Training Officer.</li>
</ul>


<br/><br/>
<b>Company Training Officer	</b><br/>
<ul>
    <li>Overall administration of the structured shipboard training programme.</li>
    <li>Monitors the progress of the Cadet. Checks and comments on the appraisal report sent by the Shipboard Training Officer.</li>
    <li>Issues guidance as required and ensures that all concerned with the training programme play their parts.</li>
</ul>
<br/><br/>
<b>Master</b><br/>
<ul>
    <li>Provides the link between the Shipboard Training Officer and the Company Training Officer/ Maritime Training Institution ashore.</li>
    <li>Ensures that all concerned are effectively carrying out the training programme.</li>
    <li>Inspects the training programme at monthly intervals and gives comments and suggestions for further improvement.</li>
</ul>

<br/><br/>
<b>Shipboard Training Officer</b>	<br/>
<ul>
    <li>Responsible for organizing the programme of practical training at sea.</li>
    <li>Ensures in a supervisory capacity, that the training programme is properly maintained and all requirements fulfilled. Ensures that the time the Cadet spends on board is as useful as possible in terms of training and experience, and activities are consistent with the objectives of the training programme, the progress of training and the ship's operational constraints. Uses the assessment criteria on the right hand side of the page and if satisfied that the Cadet can perform the tasks without supervision, signs and dates the "considered proficient" column.</li>
    <li>Inspects the training programme at monthly intervals and gives comments/ suggestions for further improvement. Sends a quarterly appraisal report on the Cadet's performance.</li>
</ul>

<br/><br/>
<b>Cadet Officer</b><br/>
<ul>
    <li>Diligently follows the training programme.</li>
    <li>Makes the most of the opportunities presented, within or outside working hours. Completes the tasks prescribed in the training programme to the best of ability, demonstrates the completion to the Shipboard Training Officer and obtains initialed approval.</li>
    <li>Keeps the training programme updated and available for scrutiny at all times.</li>
</ul>
<br/><br/>	
* In many administrations the pre-sea maritime training institution takes the responsibility of monitoring the SSTP Record Book and finally certifying that the entire training programme has been satisfactorily completed.

   </div>
            {/* End of Roles & Responsibilities content  */}
            </div>
          
          </div>
          </div>

          </div>
          </div>
    );
}

export default Comp_CRB_Roles_Resp